import ApiClient from '@afosto/api/ApiClient';

class Usage {
  constructor(client) {
    this.apiClient = client || ApiClient;
  }

  /**
   * Get a list of records
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of records
   * @returns {Promise}
   */
  listRecords(options = {}) {
    return this.apiClient.request({
      url: `/iam/records`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a list of types
   *
   * @param {Object} options - The additional request options
   * @description Returns a list of types
   * @returns {Promise}
   */
  listTypes(options = {}) {
    return this.apiClient.request({
      url: `/iam/types`,
      method: 'get',
      ...options,
    });
  }

  /**
   * Get a usage report
   *
   * @param {Object} body - Report request object
   * @param {Object} query - The optional path parameters
   * @param {Number} [query.page]
   * @param {Number} [query.pageSize]
   * @param {Object} options - The additional request options
   * @description Returns a set of usage records for given query
   * @returns {Promise}
   */
  queryUsage(body, query = {}, options = {}) {
    const params = {
      page: query.page,
      page_size: query.pageSize,
    };

    return this.apiClient.request({
      url: `/iam/report`,
      method: 'post',
      params,
      data: body,
      ...options,
    });
  }
}

export const usage = new Usage();

export default Usage;
